import React, { useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AddIcon from "@material-ui/icons/Add";
import DescriptionIcon from "@material-ui/icons/Description";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import MicIcon from "@material-ui/icons/Mic";
import ContactPhoneIcon from "@material-ui/icons/ContactPhone";
import useMessageInputStyles from "../messageInputStyles";

const FileInput = (props) => {
  const { handleChangeMedias, disableOption, hideTriggerButton, onContactPick } = props;
  const classes = useMessageInputStyles();
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDocumentClick = () => {
    handleMenuClose();
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.accept = '.pdf,.doc,.docx,.xls,.xlsx,.txt,.ppt,.pptx';
    input.onchange = (e) => handleChangeMedias(e);
    input.click();
  };

  const handlePhotoVideoClick = () => {
    handleMenuClose();
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.accept = 'image/*,video/*';
    input.onchange = (e) => handleChangeMedias(e);
    input.click();
  };

  const handleAudioClick = () => {
    handleMenuClose();
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.accept = 'audio/*';
    input.onchange = (e) => handleChangeMedias(e);
    input.click();
  };

  const handleContactClick = () => {
    handleMenuClose();
    if (onContactPick) onContactPick();
  };

  return (
    <>
      {/* ✅ INPUT OCULTO ORIGINAL */}
      <input
        multiple
        type="file"
        id="upload-button"
        disabled={disableOption()}
        className={classes.uploadInput}
        onChange={handleChangeMedias}
        accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
      />

      {!hideTriggerButton && (
        <>
      {/* ✅ BOTÓN "+" CON MENÚ DESPLEGABLE */}
      <IconButton
        aria-label="upload"
        component="span"
        disabled={disableOption()}
        title="Adjuntar archivos - Estilo WhatsApp Web"
        style={{
          backgroundColor: theme.mode === 'dark' ? '#3b82f6' : '#e3f2fd',
          borderRadius: '50%',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#2563eb' : '#bbdefb';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#3b82f6' : '#e3f2fd';
        }}
        onClick={handleMenuOpen}
      >
        <AddIcon className={classes.sendMessageIcons} style={{ color: theme.mode === 'dark' ? 'white' : '#2196f3' }} />
      </IconButton>

      {/* ✅ MENÚ DESPLEGABLE ESTILO WHATSAPP WEB */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: '12px',
            boxShadow: theme.mode === 'dark' ? '0 4px 20px rgba(0,0,0,0.5)' : '0 4px 20px rgba(0,0,0,0.15)',
            minWidth: '200px',
            padding: '8px 0',
            border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
          }
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {/* ✅ DOCUMENTOS */}
        <MenuItem
          onClick={handleDocumentClick}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#f5f5f5';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = theme.palette.background.paper;
          }}
          style={{
            padding: '12px 16px',
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <ListItemIcon style={{ minWidth: '40px' }}>
            <DescriptionIcon style={{ color: '#9c27b0', fontSize: '24px' }} />
          </ListItemIcon>
          <ListItemText
            primary="Documentos"
            primaryTypographyProps={{
              style: {
                fontSize: '14px',
                fontWeight: '500',
                color: theme.palette.text.primary,
              }
            }}
          />
        </MenuItem>

        {/* ✅ FOTOS Y VIDEOS */}
        <MenuItem
          onClick={handlePhotoVideoClick}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#f5f5f5';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = theme.palette.background.paper;
          }}
          style={{
            padding: '12px 16px',
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <ListItemIcon style={{ minWidth: '40px' }}>
            <PhotoCameraIcon style={{ color: '#2196f3', fontSize: '24px' }} />
          </ListItemIcon>
          <ListItemText
            primary="Fotos y Videos"
            primaryTypographyProps={{
              style: {
                fontSize: '14px',
                fontWeight: '500',
                color: theme.palette.text.primary,
              }
            }}
          />
        </MenuItem>

        {/* ✅ AUDIO */}
        <MenuItem
          onClick={handleAudioClick}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#f5f5f5';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = theme.palette.background.paper;
          }}
          style={{
            padding: '12px 16px',
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <ListItemIcon style={{ minWidth: '40px' }}>
            <MicIcon style={{ color: '#ff9800', fontSize: '24px' }} />
          </ListItemIcon>
          <ListItemText
            primary="Audio"
            primaryTypographyProps={{
              style: {
                fontSize: '14px',
                fontWeight: '500',
                color: theme.palette.text.primary,
              }
            }}
          />
        </MenuItem>

        {/* ✅ CONTACTOS */}
        <MenuItem
          onClick={handleContactClick}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#f5f5f5';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = theme.palette.background.paper;
          }}
          style={{
            padding: '12px 16px',
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <ListItemIcon style={{ minWidth: '40px' }}>
            <ContactPhoneIcon style={{ color: '#4caf50', fontSize: '24px' }} />
          </ListItemIcon>
          <ListItemText
            primary="Contactos"
            primaryTypographyProps={{
              style: {
                fontSize: '14px',
                fontWeight: '500',
                color: theme.palette.text.primary,
              }
            }}
          />
        </MenuItem>
      </Menu>
        </>
      )}
    </>
  );
};

export default FileInput;
